import { render, staticRenderFns } from "./integration-exchange-list.vue?vue&type=template&id=678c7a91&scoped=true"
import script from "./integration-exchange-list.vue?vue&type=script&lang=js"
export * from "./integration-exchange-list.vue?vue&type=script&lang=js"
import style0 from "./integration-exchange-list.vue?vue&type=style&index=0&id=678c7a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c7a91",
  null
  
)

export default component.exports